export { default, type FillRangeItemProps } from './FillRangeItem'
